import Item from 'common/ITEMS/Item';

const items = {
  //region Assassination
  //endregion
  //region Outlaw
  //endregion
  //region Subtlety
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
